module.exports = __webpack_public_path__ + "img/sec2_bank_img4.e049d0a4.png";